module.exports = __webpack_public_path__ + "img/grant_primary.2a1c4660.png";